var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWalletFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.36 21.985V22h23.947v-.015h.047V6.245h-2.971V2H3.343C1.697 2 .354 3.278.354 4.846c0 .155.013.306.038.454H.36v.982H.354v15.703H.36ZM3.344 3.448c-.813 0-1.475.63-1.475 1.405 0 .774.662 1.404 1.475 1.404h16.517V3.448H3.344Zm18.025 9.944h-3.11v1.442h3.11v-1.442Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWalletFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/WalletFilled.896ffb780cdbd7fa6d31050d7776b6d0.svg";